export default "__VITE_ASSET__CRdb8oBZ__"